module.exports = __webpack_public_path__ + "img/sport-types@2x.4e564c5d.png";